import { Alert, Grid } from '@gogame/components';
import { useStatusCompactDetails } from 'scenes/TapjoyBidUpdate/hooks/useStatusCompactDetails';

export default ({ statusDetails }) => {
  const getStatusCompactDetails = useStatusCompactDetails();

  return (
    <Grid item>
      <Alert title={'Bidding update request succeeded.'} severity={'success'}>
        {getStatusCompactDetails('Completed', statusDetails)}
      </Alert>
    </Grid>
  );
};
